import { Grid } from 'antd';

const { useBreakpoint: useBreakpointAntd } = Grid;

export const useBreakpoint = () => {
  const hook = useBreakpointAntd();

  return { ...hook };
};
